import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "../components/Admin/theme";
import { CommonToken } from "../api/CommonToken";
import { useNavigate } from "react-router-dom";
import "../assets/styles/AdminPage.css";
import { connect } from "react-redux";
import { setToken } from "../store/action";
import Topbar from "../components/Admin/scenes/global/Topbar";
import Sidebar from "./../components/Admin/scenes/global/Sidebar";
const AdminPage = (props) => {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const navigate = useNavigate();
  const resCT = CommonToken();

  useEffect(() => {
    if (!resCT.status) {
      navigate("/login");
    } else {
      // console.log("Initial Value", props.loginToken);
      props.setToken(resCT.token);
    }
  });

  return (
    <>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div className="adminapp">
            <Sidebar isSidebar={isSidebar} />
            <main className="admincontent">
              <Topbar setIsSidebar={setIsSidebar} />

              <Outlet />
            </main>
          </div>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </>
  );
};
const mapStateToProps = (state) => {
  // console.log("State to props : ", state);
  return {
    loginToken: state.loginToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setToken: (loginToken) => {
      // console.log("Dispatch Area : ", loginToken);
      dispatch(setToken(loginToken));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);
